import React, { useState } from "react";
import ImageManager from "./ImageManager";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faUpload, faSpinner } from "@fortawesome/free-solid-svg-icons";


const AdminPanel = ({ event, setPageName , setSelectedE}) => {
    // retrieve all the images uploaded for the event on load

  const navigate = useNavigate();
    
  useEffect(() => {
      setPageName("Edit gallery" + (event ? ` - ${event.name}` : ""));
  }, [event]);

  const gotoEvents = () => {
    setSelectedE(event.id_name);
    navigate(`/admin/events`);
  };

  return (
    /* Show the event name */
    event && (
      <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Button
          className="m-1 shadow btn-sm"
          variant="secondary"
          onClick={gotoEvents}
        >
          Go to Events
        </Button>
        <Button
          className="m-1 shadow btn-sm"
          variant="success"
          onClick={() => navigate("/admin/upload/" + event.id_name)}
        >
          <FontAwesomeIcon
            icon={faUpload}
            size="1x"
            className="me-1"
          />
          Upload more
        </Button>
          </div>


        {/* show gallery is images found, else show now images found */}
        <ImageManager event={event} admin={true}/>
      </>
    )
  );
};
export default AdminPanel;
